import { render, staticRenderFns } from "./SystemDict.vue?vue&type=template&id=544cb2b6&scoped=true&"
import script from "./SystemDict.vue?vue&type=script&lang=js&"
export * from "./SystemDict.vue?vue&type=script&lang=js&"
import style0 from "./SystemDict.vue?vue&type=style&index=0&id=544cb2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544cb2b6",
  null
  
)

export default component.exports